// extracted by mini-css-extract-plugin
module.exports = {"nav":"stickyNav-module--nav--2JkxL","navLink":"stickyNav-module--navLink--3xOym"};